<template lang="pug">
  .yz-dialog-normal-header-wrapper
    yz-card-title.d-flex.align-center.justify-space-between(:class="titleClasses" style="width: 100%;")
      slot(name="left")
        div
      slot(name="title")
        .yz-heading-8 {{ title }}
      slot(name="actions")
        yz-btn(size="md" icon-only :icon="closeIcon" :disabled="disableClose" @click="handleClose")
    yz-divider(:color="dividerColor")
</template>

<script>
import {getParentClasses, hasPaddingClasses} from '@/utils'

export default {
  name: 'YzDialogNormalHeader',
  props: {
    closeIcon: {
      type: String,
      default: 'mdi-close'
    },
    title: {
      type: String,
      default: null
    },
    dividerColor: {
      type: String,
      default: 'yz-neutral-300'
    },
    disableClose: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    titleClasses() {
      const parentClass = getParentClasses(this.$vnode)

      if (hasPaddingClasses(parentClass)) {
        // Extract and return only the padding classes
        return this.extractPaddingClasses(parentClass)
      }

      return 'px-6 py-3'
    },
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    extractPaddingClasses(classString) {
      // Extract only padding-related classes
      const classes = classString.split(' ')
      return classes.filter(c => /^(pa-|pt-|pr-|pb-|pl-|px-|py-)\d+$/.test(c)).join(' ')
    }
  }
}
</script>

<style lang="scss" scoped>
.yz-dialog-normal-header-wrapper {
  // Remove all padding that might be inherited
  padding: 0 !important;
  border-top-right-radius: 10px !important;
  border-top-left-radius: 10px !important;
}
</style>